import { render, staticRenderFns } from "./checklistRelationDocu.vue?vue&type=template&id=a8ed45d2"
import script from "./checklistRelationDocu.vue?vue&type=script&lang=js"
export * from "./checklistRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8ed45d2')) {
      api.createRecord('a8ed45d2', component.options)
    } else {
      api.reload('a8ed45d2', component.options)
    }
    module.hot.accept("./checklistRelationDocu.vue?vue&type=template&id=a8ed45d2", function () {
      api.rerender('a8ed45d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/checklist/plan/checklistRelationDocu.vue"
export default component.exports